/**
 * 繁体中文
 *  HK
 *  MO
 *  TW
 */
const zhTW = {
  process: {
    first: '邀請好友註冊',
    second: '好友首次購物並支付',
    third: '好友成功出售',
  },
  advantage: {
    you: '您可獲得',
    friend: '好友可獲得',
    account: '好友完成註冊',
    purchase: '好友首次購買並支付',
    sale: '好友出售成功',
    create: '好友首次出價',
    spreadOperation: '查看全部獎勵',
  },
  superior: {
    buyer: {
      global: {
        title: '全球潮品',
        explain: '數十萬商品供選擇',
      },
      branded: {
        title: '專業鑑別',
        explain: '全套防偽套件',
      },
      quality: {
        title: '極速成交',
        explain: '品質物流，專業配送',
      },
    },
    seller: {
      cost: {
        declare: '省時省力',
        explain: '無入駐費用、無商詳製作、營銷資源免費、運營成本低',
      },
      multiple: {
        declare: '多種模式',
        explain: '現貨直郵、閃電直發、全球買賣等多種交易模式',
      },
      fast: {
        declare: '回款快速',
        explain: '鑑別通過立即結算，三天內回款無賬期',
      },
      safe: {
        declare: '安全倉儲',
        explain: '倉儲周轉全程監控，交易安全有保障',
      },
      professional: {
        declare: '專業客服',
        explain: '專線賣家客服團隊，交易問題快速響應',
      },
    },
  },
  operate: {
    before: '邀請新用戶入駐POIZON',
    after: '繼續邀請',
  },
  /* 邀请后 */
  reward: {
    commissions: {
      title: '本月預計回傭',
      tips: {
        head: '本月預計回傭',
        content:
          '本月預計回傭以被邀請賣家當月銷售額的2%進行計算。例：你邀請一個朋友加入POIZON，朋友的月銷售額HK$20000 x 2%=HK$400，你即可獲得HK$400補貼優惠券，將於次月15日發放。',
      },
    },
    received: {
      title: '累計獎勵',
      tips: {
        head: '累計獎勵',
        content:
          '自參與該活動以來，您累計獲得的補貼獎勵金額總和，包括您邀請好友在POIZON上完成登錄、購物、出價等動作時獲得的獎勵和返佣。',
      },
    },
  },
  voucher: {
    title: '選擇單張賣家補貼券面額',
    motion: '選擇',
    confirm: {
      caption: '選擇單張賣家補貼券面額',
      note: '請注意，補貼券選擇後不可修改。',
      explain:
        '選擇後，發放賣家補貼優惠券時將優先發放你所選的單張面額。若不選擇，默認發放單張面額為HK$25的賣家補貼券。補貼券面額和應得補貼金額有差值時，實際發放時的單張補貼券面額將以所選/默認面額的倍數向上取整。',
      cancel: '取消',
      submit: '確認',
    },
  },
  rewardDetail: {
    tabName: '累計獎勵明細',
    cols: ['補貼時間', '補貼原因', '補貼類型', '補貼金額'],
    empty: '暫無邀請',
  },
  referralHistory: {
    tabName: '邀請記錄',
    col1: '累計邀請數',
    col2: '累計新賣家數',
    empty: '暫無邀請',
  },
  /* 注册/登录 */
  invite: {
    rule: '活動規則',
    offers: '送你',
    login: '立即登入',
    open1: '立即前往',
    open2: '邀請新用戶入駐POIZON',
    download: '即刻下載',
    register: {
      email: '輸入郵箱',
      password: '輸入密碼',
      code: '輸入驗證碼',
      send: '獲取驗證碼',
      resend: '重發',
      confirm: '提交',
      emailError: '請輸入有效的電郵地址',
      operate: '登入',
      passwordRule: '密碼必須至少6個字符，且包含數字和字母',
    },
  },
  /* 页面标题 */
  pageTitle: {
    inside: '新人邀請獎勵計劃',
    outside: 'POIZON邀新補貼',
  },
  /* 已注册提示 */
  registered: {
    title: '抱歉，您已經是我們的老朋友了',
    describe: '歡迎您參加我們的邀新獎勵計劃，瓜分千萬補貼',
  },
  /* 大礼包 */
  giftBag: {
    title: '新人禮包',
    content: '請去首頁領取新人禮包',
    confirm: '我知道了',
  },
}

/**
 * 英文
 * HK
 * JP
 * US
 */
const en = {
  process: {
    first: 'Invite a friend to register an account',
    second: 'Friend makes a first purchase',
    third: 'Friend completes a sale',
  },
  advantage: {
    you: 'You get',
    friend: 'Friend gets',
    account: 'When Friend registers an account',
    purchase: 'When Friend makes a first purchase',
    sale: 'When Friend completes a sale',
    create: 'When Friend creates a first listing',
    spreadOperation: 'View all rewards & coupons',
  },
  superior: {
    buyer: {
      global: {
        title: 'Curated Fashion',
        explain: 'Globally sourced',
      },
      branded: {
        title: 'Authentication Heritage',
        explain: 'Branded tamper-proof packaging',
      },
      quality: {
        title: 'Premium Experience',
        explain: 'Quality delivery service',
      },
    },
    seller: {
      cost: {
        declare: 'Cost and Time Efficient',
        explain:
          'No entry fee. No need to create product pages. Free marketing resources. Low operational cost',
      },
      multiple: {
        declare: 'Multiple Selling Options',
        explain: 'Standard listing, instant sale, consignment sale, etc',
      },
      fast: {
        declare: 'Fast Payouts',
        explain: 'Proceeds are transferred to sellers within 3 days of passing authentication',
      },
      safe: {
        declare: 'Safe Storage',
        explain: 'Monitor-mounted warehouses for your inventory storage',
      },
      professional: {
        declare: 'Professional Customer Service',
        explain: 'Dedicated & highly responsive to sellers',
      },
    },
  },
  operate: {
    before: 'Invite a Friend',
    after: 'Invite More',
  },
  /* 邀请后 */
  reward: {
    commissions: {
      title: 'Estimated Commissions',
      tips: {
        head: 'Estimated Commissions of This Month',
        content:
          "The commissions that you are expected to receive of the current month are based on the Invitee Seller's (i.e., your referred friend) sales. The commission amount equals 2% of the Invitee Seller’s sales of the same month. For example, you successfully invited a friend to join POIZON and he/she later achieved a monthly sales amount of HK$20000. You’re hence expected to receive a commission of HK$400 (HK$20000 x 2% = HK$400) in the form of seller reward credits on the 1st day next month.",
      },
    },
    received: {
      title: 'Rewards Received',
      tips: {
        head: 'Total Rewards Received',
        content:
          'Total value of rewards and benefits that you received for your referral efforts within the referral event period, including successful referrals of user login/registration, purchase, listing for sale, etc.',
      },
    },
  },
  voucher: {
    title: 'Select reward amount per voucher',
    motion: 'Select',
    confirm: {
      caption: 'Select reward amount per voucher',
      note: 'Note: Your choice is non-reversible once confirmed.',
      explain:
        'Your choice of face value per voucher will be given priority when we send Reward Vouchers for Sellers to your account. Default face value is HK$25 in the absence of your choice. In the case of a discrepancy between face value totals and total rewards receivable, the actual face value per voucher rounds up to the closest multiple of the selected (or default) face value.',
      cancel: 'Cancel',
      submit: 'Confirm',
    },
  },
  rewardDetail: {
    tabName: 'Total Rewards Details',
    cols: ['Time', 'Reason', 'Type', 'Value'],
    empty: 'You have no invites.',
  },
  referralHistory: {
    tabName: 'Referral History',
    col1: 'Total Invites',
    col2: 'Total New Sellers',
    empty: 'You have no invites.',
  },
  /* 注册/登录 */
  invite: {
    rule: 'Rules',
    offers: 'offers you',
    login: 'LOG IN',
    open1: 'OPEN POIZON',
    open2: 'Invite a Friend',
    download: 'Download Now',
    register: {
      email: 'Email address',
      password: 'Password',
      code: 'Verification code',
      send: 'Send code',
      resend: 'Resend',
      confirm: 'CONFIRM',
      emailError: 'Please enter a valid email address.',
      operate: 'LOG IN',
      passwordRule:
        'Password must be at least 6 characters and contain a combination of numbers and letters.',
    },
  },
  /* 页面标题 */
  pageTitle: {
    inside: 'Referral Program',
    outside: 'POIZON Welcome Offers',
  },
  /* 已注册提示 */
  registered: {
    title: "Sorry, you've already registered an account with us.",
    describe: 'You’re welcome to join our Referral Program and earn rewards.',
  },
  /* 大礼包 */
  giftBag: {
    title: 'Welcome Package',
    content: 'Please go to the main page to claim our new user exclusive offers.',
    confirm: 'OK',
  },
}

const languages = {
  // 英文
  en,
  // 香港繁中
  'zh-TW': zhTW,
  // 台湾繁中
  'zh-TW2': zhTW,
  // 澳门繁中
  'zh-MO': zhTW,
  // 日文
  ja: {
    process: {
      first: '友達を招待して登録',
      second: '友達が初購入の支払い完了',
      third: '友達が出品成功',
    },
    advantage: {
      you: '自分獲得可能',
      friend: '友達獲得可能',
      account: '友達が登録完了',
      purchase: '友達が初購入の支払い完了',
      sale: '友達が出品成功',
      create: '友達が初出品',
      spreadOperation: 'すべての報酬を確認',
    },
    superior: {
      buyer: {
        global: {
          title: 'グローバルファッショントレンド',
          explain: '商品勢揃い',
        },
        branded: {
          title: '専門鑑定',
          explain: '鑑定証明付き',
        },
        quality: {
          title: '簡単取引',
          explain: '優れたロジスティックサービス',
        },
      },
      seller: {
        cost: {
          declare: '時間と運営作業削減',
          explain: '出品無料、商品詳細制作不要、マーケティングルート無料使用、低運営コスト',
        },
        multiple: {
          declare: '多様な発送種類',
          explain: '在庫発送、快速発送、グローバル販売などさまざまな取引方法',
        },
        fast: {
          declare: '快速入金',
          explain: '鑑定合格で即決算、3日以内に入金、支払請求期間なし',
        },
        safe: {
          declare: '安全な倉庫保存',
          explain: '全範囲に防犯カメラ設置、安全な取引を保障',
        },
        professional: {
          declare: 'プロのカスタマーサービス',
          explain: 'オンライン出品者カスタマーサービス、取引問題に迅速に対応',
        },
      },
    },
    operate: {
      before: '友達を招待しよう',
      after: '続き招待',
    },
    /* 邀请后 */
    reward: {
      commissions: {
        title: '今月推定クーポン',
        tips: {
          head: '今月推定クーポン',
          content:
            '今月推定クーポンは招待された出品者当月の売上額の2%。例：友達をPOIZONに招待し、友達の月売上額は￥300000 x 2%=￥6000、あなたが獲得できるクーポン割引券は￥6000、来月の15日に配布されます。',
        },
      },
      received: {
        title: '累計報酬',
        tips: {
          head: '累計報酬',
          content:
            'このイベントに参加してから獲得したクーポン報酬総金額、招待された友達がPOIZONに登録、購入、出品などした時に獲得した報酬とクーポンを含みます。',
        },
      },
    },
    voucher: {
      title: '単枚手数料クーポン券の面額を選択',
      motion: '選択',
      confirm: {
        caption: '単枚手数料クーポン券の面額を選択',
        note: '注意：クーポン券選択後は修正不可。',
        explain:
          '選択した後、出品者手数料クーポン割引券が配布される際、優先的に選択した金額が配布されます。選択しない場合、￥300円文の手数料クーポン券が配布されます。クーポン券面額と取り分の金額数に差がある場合、実際配布する時の単枚クーポン券の面額金額は、選択した/デフォルトの面額倍数に繰り上げられて整数になります。',
        cancel: '取消',
        submit: '確認',
      },
    },
    rewardDetail: {
      tabName: '累計報酬詳細',
      cols: ['クーポン時間', 'クーポン類型', 'クーポン種類', 'ボーナス金額'],
      empty: '招待情報がありません',
    },
    referralHistory: {
      tabName: '招待記録',
      col1: '累計招待数',
      col2: '累計新出品者数',
      empty: '招待情報がありません',
    },
    /* 注册/登录 */
    invite: {
      rule: 'イベント説明',
      offers: 'をゲット',
      login: '今すぐログイン',
      open1: '移動',
      open2: '友達を招待しよう',
      download: '今すぐダウンロード',
      register: {
        email: 'メールアドレス入力',
        password: 'パスワード',
        code: '認証コードを入力',
        send: '認証コード取得',
        resend: '再送信する',
        confirm: '提出',
        emailError: '有効のメールアドレスを入力してください',
        operate: 'ログイン',
        passwordRule: '半角英数字６文字以上',
      },
    },
    /* 页面标题 */
    pageTitle: {
      inside: '友達招待キャンペーン',
      outside: 'POIZON新人招待クーポン',
    },
    /* 已注册提示 */
    registered: {
      title: 'すみません、既に登録したユーザーです',
      describe: '新人招待計画へ参加し、クーポンを獲得しよう',
    },
    /* 大礼包 */
    giftBag: {
      title: '新人ギフト',
      content: 'トップページで新人ギフトを受け取ってください',
      confirm: 'OK',
    },
  },
  // 简体中文
  zh: {
    process: {
      first: '邀请好友注册',
      second: '好友首次购物并支付',
      third: '好友成功出售',
    },
    advantage: {
      you: '您可获得',
      friend: '好友可获得',
      account: '好友完成注册',
      purchase: '好友首次购买并支付',
      sale: '好友出售成功',
      create: '好友首次出价',
      spreadOperation: '查看全部奖励',
    },
    superior: {
      buyer: {
        global: {
          title: '全球潮品',
          explain: '数十万商品供选择',
        },
        branded: {
          title: '专业鉴别',
          explain: '全套防伪套件',
        },
        quality: {
          title: '极速成交',
          explain: '品质物流，专业配送',
        },
      },
      seller: {
        cost: {
          declare: '省时省力',
          explain: '无入驻费用、无商详制作、营销资源免费、运营成本低',
        },
        multiple: {
          declare: '多种模式',
          explain: '现货直邮、闪电直发、全球买卖等多种交易模式',
        },
        fast: {
          declare: '回款快速',
          explain: '鉴别通过立即结算，三天内回款无账期',
        },
        safe: {
          declare: '安全仓储',
          explain: '仓储周转全程监控，交易安全有保障',
        },
        professional: {
          declare: '专业客服',
          explain: '专线卖家客服团队，交易问题快速响应',
        },
      },
    },
    operate: {
      before: '邀请新用户入驻POIZON',
      after: '继续邀请',
    },
    /* 邀请后 */
    reward: {
      commissions: {
        title: '本月预计回佣',
        tips: {
          head: '本月预计回佣',
          content:
            '本月预计回佣以被邀请卖家当月销售额的2%进行计算。例：你邀请一个朋友加入POIZON，朋友的月销售额HK$20000 x 2%=HK$400，你即可获得HK$400补贴优惠券，将于次月1日发放。',
        },
      },
      received: {
        title: '累计奖励',
        tips: {
          head: '累计奖励',
          content:
            '自参与该活动以来，您累计获得的补贴奖励金额总和，包括您邀请好友在POIZON上完成登录、购物、出价等动作时获得的奖励和返佣。',
        },
      },
    },
    voucher: {
      title: '选择单张卖家补贴券面额',
      motion: '选择',
      confirm: {
        caption: '选择单张费率补贴券面额',
        note: '请注意，补贴券选择后不可修改。',
        explain:
          '选择后，发放卖家费率补贴优惠券时将优先发放你所选的单张面额。若不选择，默认发放单张面额为HK$25的费率补贴券。补贴券面额和应得补贴金额有差值时，实际发放时的单张补贴券面额将以所选/默认面额的倍数向上取整。',
        cancel: '取消',
        submit: '确认',
      },
    },
    rewardDetail: {
      tabName: '累计奖励明细',
      cols: ['补贴时间', '补贴原因', '补贴类型', '补贴金额'],
      empty: '暂无邀请',
    },
    referralHistory: {
      tabName: '邀请记录',
      col1: '累计邀请数',
      col2: '累计新卖家数',
      empty: '暂无邀请',
    },
    /* 注册/登录 */
    invite: {
      rule: '活动规则',
      offers: '送你',
      login: '立即登录',
      open1: '立即前往',
      open2: '邀请新用户入驻POIZON',
      download: '立即下载',
      register: {
        email: '输入邮箱',
        password: '输入密码',
        code: '输入验证码',
        send: '获取验证码',
        resend: '重发',
        confirm: '提交',
        emailError: '邮箱格式不正确',
        operate: '登录',
        passwordRule: '密码必须至少6个字符，且包含数字和字母',
      },
    },
    /* 页面标题 */
    pageTitle: {
      inside: '新人邀请奖励计划',
      outside: 'POIZON邀新补贴',
    },
    /* 已注册提示 */
    registered: {
      title: '抱歉，您已经是我们的老朋友了',
      describe: '欢迎您参加我们的邀新奖励计划，瓜分千万补贴',
    },
    /* 大礼包 */
    giftBag: {
      title: '新人礼包',
      content: '请去首页领取新人礼包',
      confirm: '我知道了',
    },
  },
}

export default languages
